module.exports = __webpack_public_path__ + "static/media/blrss5.ce46122d.png";